import { Box, IconButton, Grid, Tooltip } from '@mui/material';
import MaterialTable from 'material-table';
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import EditIcon from '@mui/icons-material/Edit';
import Popup from "../../../../Base/views/Popup"
import { useState } from 'react';
import { 
    GetFoodAllowanceAction,
     } from '../../../../../../store/Finance/PayRollTemplate/Action';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import FoodAllowance from './FoodAllowance';

const FoodAllowanceGrid = () => {
    const dispatch = useDispatch();
    const { food_allowance_data, isLoadingFoodAllowance } = useSelector(state => state.FinanceReducer?.PayrollTemplateReducer);
    const [editedRecord, setEditedRecord] = useState(null);
    const [openPopup, setOpenPopup] = useState(false);

  useEffect(() => {
        dispatch(GetFoodAllowanceAction());          
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [])
    const handleEdit = (rowData) => {
        setEditedRecord(rowData);
        setOpenPopup(true);
    };

    const addMode = (resetForm) => {
        resetForm();
        setEditedRecord(null);
        setOpenPopup(false);
    };

    return (
        <Grid container spacing={2} style={{ padding: "10px 0px" }}>
            <Grid item xs={12} md={12}>
                <Box>
                    <MaterialTable
                        isLoading={isLoadingFoodAllowance}
                        columns={[
                             { 
                                title: "Allowance Type", 
                                field: "food_allowance_type", 
                                cellStyle: { padding: "10px 10px 10px 13px" } 
                            },
                            { 
                                 title: (
                                    <span>
                                        Flat Amount / Month&nbsp;
                                        <Tooltip title="A fixed monthly amount pro-rated based on attendance. Paid only if minimum eligible days are met." placement="top" arrow>
                                            <InfoOutlinedIcon fontSize="small" color="action" style={{ verticalAlign: "middle", cursor: "pointer" }} />
                                        </Tooltip>
                                    </span>
                                ),
                                field: "flat_amount", 
                                cellStyle: { padding: "10px 10px 10px 15px" },
                                hidden: food_allowance_data?.[0]?.food_allowance_type === "Variable"
                            },
                            { 
                                title: (
                                    <span>
                                       Min. Eligible Days&nbsp;
                                        <Tooltip title="Minimum number of working days required to receive any food allowance." placement="top" arrow>
                                            <InfoOutlinedIcon fontSize="small" color="action" style={{ verticalAlign: "middle", cursor: "pointer" }} />
                                        </Tooltip>
                                    </span>
                                ),
                                field: "min_food_allowance_days", 
                                cellStyle: { padding: "10px 10px 10px 15px" },
                                hidden: food_allowance_data?.[0]?.food_allowance_type === "Flat"
                            },
                            { 
                                title: (
                                    <span>
                                        Per-Day Amount&nbsp;
                                        <Tooltip title="Daily food allowance amount multiplied by eligible working days." placement="top" arrow>
                                            <InfoOutlinedIcon fontSize="small" color="action" style={{ verticalAlign: "middle", cursor: "pointer" }} />
                                        </Tooltip>
                                    </span>
                                ),
                                field: "variable_food_allowance_daily_rate", 
                                cellStyle: { padding: "10px 10px 10px 15px" },
                                hidden: food_allowance_data?.[0]?.food_allowance_type === "Flat"
                            },
                            { 
                                title: (
                                    <span>
                                        Max. Monthly Limit&nbsp;
                                        <Tooltip title="Maximum food allowance payable in a month, regardless of eligible days" placement="top" arrow>
                                            <InfoOutlinedIcon fontSize="small" color="action" style={{ verticalAlign: "middle", cursor: "pointer" }} />
                                        </Tooltip>
                                    </span>
                                ),
                                field: "variable_food_allowance_max_rate", 
                                cellStyle: { padding: "10px 10px 10px 15px" },
                                hidden: food_allowance_data?.[0]?.food_allowance_type === "Flat"
                            }
                        ]}
                        data={food_allowance_data}
                        options={{
                            maxBodyHeight: 220,
                            rowStyle: { fontSize: "13px" },
                            headerStyle: { padding: "5px 10px 5px 10px", fontWeight: "bold", height:"60px" },
                            sorting: false,
                            search: false,
                            searchFieldAlignment: "right",
                            searchAutoFocus: true,
                            searchFieldVariant: "standard",
                            filtering: false,
                            paging: false,
                            selection: false,
                            actionsColumnIndex: -1,
                            grouping: false,
                            addRowPosition: "first",
                        }}
                        actions={[
                            {
                                icon: () => <IconButton sx={{ padding: "0px" }}><EditIcon /></IconButton>,
                                tooltip: "Edit",
                                onClick: (_event, rowData) => { handleEdit(rowData) },
                            },
                        ]}
                        title= ""
                        components={{
                            Toolbar: props => (
                                <div style={{
                                    minHeight: "10px",
                                    padding: "10px 25px",
                                    borderRadius:"5px 5px 0px 0px"
                                }}>
                                    {props.title}
                                </div>
                            )
                        }}
                    />
                    <Popup
                        fullWidth={true}
                        maxWidth="sm"
                        title={editedRecord ? "Edit" : "Add"}
                        openPopup={openPopup}
                        setOpenPopup={setOpenPopup}

                    >
                        <FoodAllowance editedRecord={editedRecord} addMode={addMode} setOpenPopup={setOpenPopup} />
                    </Popup>
                </Box>
            </Grid>
        </Grid>
    );
}

export default FoodAllowanceGrid;
